import { createFormHandler } from './CreateFormStmt';
import { createInsideFormHandler } from './CreateInsideFormStmt';
import { removeFormHandler } from './RemoveFormStmt';
import { removeInsideFormHandler } from './RemoveInsideFormStmt';
import { sortFormFieldsHandler } from './SortFormFieldsStmt';
export * from './CreateFormStmt';
export * from './CreateInsideFormStmt';
export * from './RemoveFormStmt';
export * from './RemoveInsideFormStmt';
export * from './SortFormFieldsStmt';
export * from './formInstruction';
export const formHandlers = [createFormHandler, createInsideFormHandler, removeFormHandler, removeInsideFormHandler, sortFormFieldsHandler];
//# sourceMappingURL=index.js.map